/*
 * VUE_APP_SOLUTION in .env should match one of these Solutions
 */
export enum Solution {
    DanishCrown = 'DANISH_CROWN',
    Whitelabel = 'WHITELABEL',
    Yoda = 'YODA',
    Kls = 'KLS',
}
